export function submibNewLetterData(data) {
    return {type: "SET_NEWS_LETTER", payload:data};
}
export function submibNewLetterError(data) {
    return {type: "SET_NEWS_LETTER_FAILLURE", payload:data};
}
export const handleResetMessages=()=>{
    return {type:"RESET_NEWS_LETTER_MESSAGES", payload:{}}
}